/**
 * Layer data operations: add, remove, reorder, toggle visibility/lock.
 */
export class LayerModel {
  constructor(state) {
    this.state = state;
  }

  addTileLayer(name) {
    const layers = this.state.get('layers');
    const mapW = this.state.get('mapWidth');
    const mapH = this.state.get('mapHeight');
    layers.push({
      name: name || `Layer ${layers.length + 1}`,
      type: 'tilelayer',
      data: new Uint32Array(mapW * mapH),
      visible: true,
      locked: false,
      opacity: 1,
      properties: {},
    });
    this.state._notify('layers', layers, layers);
    this.state.set('activeLayerIndex', layers.length - 1);
  }

  addObjectLayer(name) {
    const layers = this.state.get('layers');
    layers.push({
      name: name || `Objects ${layers.length + 1}`,
      type: 'objectgroup',
      objects: [],
      visible: true,
      locked: false,
      opacity: 1,
      properties: {},
    });
    this.state._notify('layers', layers, layers);
    this.state.set('activeLayerIndex', layers.length - 1);
  }

  removeLayer(index) {
    const layers = this.state.get('layers');
    if (layers.length <= 1) return;
    layers.splice(index, 1);
    const active = this.state.get('activeLayerIndex');
    if (active >= layers.length) {
      this.state.set('activeLayerIndex', layers.length - 1);
    }
    this.state._notify('layers', layers, layers);
  }

  moveLayer(fromIndex, toIndex) {
    const layers = this.state.get('layers');
    if (toIndex < 0 || toIndex >= layers.length) return;
    const [layer] = layers.splice(fromIndex, 1);
    layers.splice(toIndex, 0, layer);
    this.state.set('activeLayerIndex', toIndex);
    this.state._notify('layers', layers, layers);
  }

  toggleVisibility(index) {
    const layers = this.state.get('layers');
    layers[index].visible = !layers[index].visible;
    this.state._notify('layers', layers, layers);
  }

  toggleLock(index) {
    const layers = this.state.get('layers');
    layers[index].locked = !layers[index].locked;
    this.state._notify('layers', layers, layers);
  }

  setOpacity(index, opacity) {
    const layers = this.state.get('layers');
    layers[index].opacity = opacity;
    this.state._notify('layers', layers, layers);
  }

  duplicateLayer(index) {
    const layers = this.state.get('layers');
    const src = layers[index];
    if (!src) return;

    const copy = {
      ...src,
      name: src.name + ' copy',
      visible: src.visible,
      locked: false,
      opacity: src.opacity ?? 1,
      properties: { ...src.properties },
    };

    if (src.data) {
      copy.data = new Uint32Array(src.data);
    }
    if (src.objects) {
      copy.objects = src.objects.map(o => ({ ...o }));
    }

    layers.splice(index + 1, 0, copy);
    this.state.set('activeLayerIndex', index + 1);
    this.state._notify('layers', layers, layers);
  }

  renameLayer(index, name) {
    const layers = this.state.get('layers');
    layers[index].name = name;
    this.state._notify('layers', layers, layers);
  }
}
